import { render, staticRenderFns } from "./SmartProfile.vue?vue&type=template&id=2e8297f4&"
import script from "./SmartProfile.vue?vue&type=script&lang=ts&"
export * from "./SmartProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports